import { render, staticRenderFns } from "./searchAirbnbAipoBkmt.vue?vue&type=template&id=89487b2c"
import script from "./searchAirbnbAipoBkmt.vue?vue&type=script&lang=js"
export * from "./searchAirbnbAipoBkmt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports